import type { DiamTeam } from '../../diamApi';
import { NONE_OPTION_VALUE } from '../../constants';
import {
  CreateTeamFormData,
  OptionalModifierFieldConfig,
} from '../CreateTeamDrawer/types';
import { getDefaultCreateTeamFormData } from '../CreateTeamDrawer/formUtils';

export function getEditTeamFormDataFromApi(
  team: DiamTeam,
  applicationContextIds: string[],
  config: OptionalModifierFieldConfig[],
): CreateTeamFormData {
  const defaults = getDefaultCreateTeamFormData(config);
  const accountValue = team.modifiers?.account?.value?.trim();
  const locationValue = team.modifiers?.location?.value?.trim();
  const expiresValue = team.modifiers?.expires?.value?.trim();

  return {
    ...defaults,
    name: team.name,
    applications: applicationContextIds,
    parentTeamId: team.parent?.id ?? '',
    account: accountValue || NONE_OPTION_VALUE,
    locationIds: locationValue ? [locationValue] : [],
    optionalModifiers: {
      ...defaults.optionalModifiers,
      ...(expiresValue ? { expires: expiresValue } : {}),
    },
  };
}
